export default defineNuxtRouteMiddleware(async (to, from) => {
  if (to.path.includes('/api')) return

  const sAccount  = useState('account')
  const sSettings = useState('settings')
  const sPoints   = useState('points')
  const cTokens   = useCookie('tokens')
  const cSetupped = useCookie('setupped', {
    maxAge: 24 * 60 * 60 // 24h
  })


  if (to.query['clear-cookie'] === '1') {
    cSetupped.value = undefined
    cTokens.value = undefined
  }

  const {
    getBrowsingHistory,
    getProducer,
    checkSetting,
    getSettings,
    getAccount,
    getPoint,
  } = useDatabase()
  const { tokens, data, refresh, signOut } = useAuth()

  const isSetupPage   = to.path.includes('/setup')
  const isRecoverPage = to.path.includes('/recover')
  const isRegistPage  = to.path.includes('/regist')
  const isLoginPage   = to.path.includes('/login')
  const isTopPage     = to.path === '/'
  const isAdminPage   = to.path.includes('/admin')
  const isPublicPage  = to.path.includes('/pub')
  const isProducerPage = to.path.startsWith('/producer')
  const isCompletePage = to.path.includes('/complete')
  const isBeginnerPage = to.path.includes('/beginner')

  // 初期設定が完了しているかチェック
  if (!Boolean(cSetupped.value) || cSetupped.value == false) {
    cSetupped.value = await checkSetting()
  }

  try {
    if (cSetupped.value) { // 設定が完了している場合
      // 完了ページの場合、処理を終了

      if (!sAccount.value)  sAccount.value  = await getAccount()
      if (!sSettings.value) sSettings.value = await getSettings()

      if (isCompletePage) return

       // 設定ページの場合、元のページにリダイレクト
      if (isSetupPage) return navigateTo('/')

      if (tokens.value) {
        // ===================================
        // トークンが存在するか確認

        await refresh() // トークンリフレッシュを実行

        // ポイント情報を取得し、`state:points`に保存
        if (!sPoints.value) sPoints.value = await getPoint().then(({total}) => total)

        if (isPublicPage || isRegistPage || isRecoverPage) {
          // ------------------------------------------------------------
          // 公開ページ、登録ページ、リカバリーページの場合、処理を終了
          return
        } else if (isLoginPage) {
          // ------------------------------------------------------------
          // ログインページの場合、リダイレクト
          return navigateTo(isAdminPage ? '/admin' : '/')
        } else if (isProducerPage) {
          if (!isAdminPage) {
            // ------------------------------------------------------------
            // プロデューサーページの場合の処理
            const cuid = to.params.cuid // プロデューサーIDを取得

            // 閲覧履歴から支払い済みかを確認
            const isPaid = await getBrowsingHistory(cuid)
            const isDetailPage = to.path.includes('/detail')
            const producer = await getProducer(cuid)

            if (data.value?.producer && data.value?.producer == producer.id) {
              // 自分の生産者ページの場合、詳細ページにリダイレクト
              // 課金後詳細ページ
              if (!isDetailPage) return navigateTo(`/producer/${cuid}/detail`)
            } else {
              if (isDetailPage) { // 詳細ページ
                // 未支払いの場合、プロデューサーページにリダイレクト
                if (!isPaid) return navigateTo(`/producer/${cuid}`)
                return
              } else { // 詳細ページ以外
                // 支払い済みなら詳細ページにリダイレクト
                if (isPaid) return navigateTo(`/producer/${cuid}/detail`)
                return
              }
            }
          }
        } else if (isAdminPage) {
          // ------------------------------------------------------------
          // 管理者ページの場合
          if (data.value.type == 'admin') {
            // 管理者のときは何もしない
            return
          } else {
            // ユーザーが管理者でなければエラーを投げる
            return createError({
              statusCode: 403,
              message: '権限がありません。'
            })
          }
        } else {
          return
        }
      } else {
        // ===================================
        // トークンがない場合の処理
        if (
          isLoginPage     ||  // ログインページ
          isTopPage       ||  // トップページ
          isBeginnerPage  ||  // 「初めての方」ページ
          isPublicPage    ||  // 公開ページ
          isRegistPage    ||  // 登録ページ
          isRecoverPage   ||  // パスワード変更ページ
          (isProducerPage && !to.path.includes('/detail'))
        ) {
          return  // ログインページの場合は何もしない
        } else {
          // ログアウト処理とログインページへのリダイレクトを実行
          // return signOut({
          //   path: `${isAdminPage ? '/admin' : ''}/login`,
          //   query: { redirect_to: to.path }
          // })
        }
      }
    } else { // 設定が未完了の場合
      // 設定ページ以外なら設定ページへリダイレクト
      if (!isSetupPage) return navigateTo('/setup')
    }
  } catch (e) {
    sSettings.value = {}  // 設定をクリア

    // if (!isLoginPage) {
    //   // エラー時にログインページにリダイレクト
    //   return signOut(isAdminPage ? '/admin/login' : '/login')
    // }
    throw createError({
      statusCode: e.statusCode,
      message: `${e.message}\n${JSON.stringify(e, null, 2)}`,
    })
  } finally {
    // console.groupEnd('/src/middleware/01.auth.global.js')
  }
})
